import * as React from 'react';

import { CaseFileStaticItems } from '../../../../utilities/Constants';
import CheckmateSelect from '../../../shared/CheckmateSelect';
import CheckmateSelectHelper from '../../../../utilities/CheckmateSelectHelper';
import { IMultiSelectOption } from '../../../../interfaces/ILookup';

export interface ICasePriorityControlProps {
    onChange: (selectedOption: IMultiSelectOption, staticItemId: number) => void;
    value: boolean | undefined;
}

export function CasePriorityControl(props: ICasePriorityControlProps) {
    return (
        <CheckmateSelect
            options={CheckmateSelectHelper.getBooleanOptions()}
            value={CheckmateSelectHelper.getBooleanOptionValue(props.value)}
            onChange={(selectedOption: IMultiSelectOption) => {
                props.onChange(selectedOption, CaseFileStaticItems.CasePriority.Id);
            }}
        />
    );
}
